import { render, staticRenderFns } from "./ListaDeFacturasExterno.vue?vue&type=template&id=a56e3cd8"
import script from "./ListaDeFacturasExterno.vue?vue&type=script&lang=js"
export * from "./ListaDeFacturasExterno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports